<script>
import { mapActions, mapState } from "vuex";

import documentMixin from "@/mixins/documentMixin";

import dateMixin from "@/mixins/dateMixin";

export default {
  mixins: [documentMixin, dateMixin],
  data() {
    return {
      headers: [
        {
          text: "Tipo documento",
          value: "document_type",
          sortable: false,
          align: "center"
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
          align: "center"
        },
        {
          text: "Situação",
          value: "approved",
          sortable: false,
          align: "center"
        },
        {
          text: "Data criacao",
          value: "created_at",
          sortable: false,
          align: "center"
        },
        {
          text: "Data edicao",
          value: "updated_at",
          sortable: false,
          align: "center"
        }
      ],
      background_check_documents: [],
      loader: false
    };
  },
  props: {
    professional: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions("documents", ["listAllDocuments", "approveDocument"]),
    async listDocuments() {
      this.loader = true;
      try {
        await this.listAllDocuments(this.professional.account.id);
      } catch (e) {
        this.$toast.error(
          "Ocorreu um erro ao listar os antecedentes do profissional"
        );
      }
      this.loader = false;
    },

    filterBackgroundCheckDocuments() {
      return Object.values(this.documents).filter(el => {
        return this.isBackgroundCheckDocument(el.document_type);
      });
    },
    formatExternalId(externalId = null) {
      return !externalId ? "Ainda não registrado" : externalId;
    }
  },
  computed: {
    ...mapState("documents", ["documents"])
  },
  async mounted() {
    await this.listDocuments();
    this.background_check_documents = this.filterBackgroundCheckDocuments();
  }
};
</script>

<template>
  <div>
    <div
      v-if="!background_check_documents.length"
      class="unset_background_check_documents"
    >
      <p>
        Profissional ainda nao chegou na etapa de verificacao dos antecedentes
        :(
      </p>
    </div>

    <div v-else>
      <v-btn
        class="ma-2"
        :href="
          buildCombateAFraudeLink(background_check_documents[0].external_id)
        "
        color="secondary"
        target="_blank"
      >
        Consultar execução
      </v-btn>
      <v-data-table
        :headers="headers"
        :items="background_check_documents"
        :loading="loader"
        show-expand
      >
        <template v-slot:item.document_type="{ headers, item }">
          {{ item.document_type | getBackgroundDocumentTypeStatuses }}
        </template>

        <template v-slot:item.status="{ headers, item }">
          {{ item.status | getStatuses("name") }}
        </template>

        <template v-slot:item.approved="{ headers, item }">
          <p v-if="item.status === 'reproved' || item.status === 'approved'">
            {{ item.approved | isApproved().name }}
          </p>
          <p v-else>
            Em andamento
          </p>
        </template>

        <template v-slot:item.created_at="{ headers, item }">
          {{ item.created_at | formatDate("DD/MM/Y") }}
        </template>

        <template v-slot:item.updated_at="{ headers, item }">
          {{ item.updated_at | formatDate("DD/MM/Y") }}
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <p class="mt-5">
              <b>Combate a fraude ID:</b>
              {{ formatExternalId(item.external_id) }}
            </p>
            <v-btn
              v-if="isDocumentHandled(item.status)"
              color="yellow"
              :loading="item.documentApprovingLoader"
              small
              @click="approveDocument(item)"
            >
              <span>Aprovar Documento</span>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<style scoped>
.unset_background_check_documents {
  font-size: 30px;
  text-align: center;
  margin-top: 20px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  width: 100%;
  height: 100%;
  margin: 0;
  color: #2196f3;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Documents/BackgroundCheck.vue